import { getUrls } from "@portal/app/_common/lib/urls";

/**
 * Converts absolute URLs to relative paths.
 * Needed because PayloadCMS may return absolute URLs like https://dreambound.com/explore
 * which would bypass localhost during development.
 */
export const toRelativePath = (url: string): string => {
  if (!url) return getUrls().Explore();
  try {
    if (url.startsWith("http://") || url.startsWith("https://")) {
      const parsed = new URL(url);
      return parsed.pathname + parsed.search;
    }
    return url;
  } catch {
    return url;
  }
};
